import { MultiSelect } from "#components/molecules/MultiSelect/MultiSelect";

type Props = {
  data: { value: string; label: string }[];
  value: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
};

export const SurfaceTreatmentSelect = ({
  data,
  value,
  onChange,
  disabled,
  label,
  placeholder = "",
}: Props) => {
  return (
    <MultiSelect
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label}
      placeholder={placeholder}
      clearable
      searchable
    />
  );
};
